import React from 'react'
import { Link } from 'react-router-dom'
import "./module3.css"

export default function Module3() {
  return (
    <>
      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading28">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse28" aria-expanded="false" aria-controls="collapse28">
              Post Study Work Visa
            </button>
          </h2>
          <div id="collapse28" className="accordion-collapse collapse" aria-labelledby="heading28" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <p>All international students who have graduated from a Canadian post‐secondary institution You are eligible for Post Study Work Visa to gain valuable Canadian work experience.</p>
              <p>To be eligible for a Post Study Work Visa, international students</p>
              <ul>
                <li className="my-1">Should have studied full‐time for at least eight months preceding the completion of  their program and have graduated from a Designated Learning Institution.</li>
                <li className="my-1">Must have completed and passed the program of study and received written  notification that they are eligible to obtain their degree, diploma, or certificate.</li>
                <li className="my-1">Must apply for a post study  work permit within 90 days of receiving written  confirmation from their academic institution that they have met the requirements of  their program.</li>
                <li className="my-1">Must have a valid study permit when applying for the post study work permit.</li>
                <li className="my-1">The Post Study Work Visa provides no restrictions on the type of employment and requirement of a job offer.</li>
              </ul>
              <Link style={{ color: "black" }} to={"https://www.canada.ca/en/immigration-refugees-citizenship/services/study-canada/work/after-graduation/about.html"} target='blank'><li><strong>Starting February 15, 2024,</strong> students who graduate from master’s degree programs of less than 2 years (8 months minimum) may be eligible for a 3 year PGWP. <span style={{ color: "tomato" }}> Please Refer To This Link</span></li></Link>
              <Link style={{ display: "inline-block", color: "black" }} to={"https://www.canada.ca/en/immigration-refugees-citizenship/services/study-canada/work/after-graduation/about.html"} target='blank'><li><strong>For all other programs</strong><span style={{ color: "tomato", fontSize: "13px" }}> Please Refer To This Link</span></li></Link>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading29">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse29" aria-expanded="false" aria-controls="collapse29">
              What is PAL/TAL?
            </button>
          </h2>
          <div id="collapse29" className="accordion-collapse collapse" aria-labelledby="heading29" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <h3>You need a Provincial Attestation Letter (PAL) or Territorial Attestation Letter (TAL) to apply for a study permit</h3>
              <p>The study permit is a document we issue that allows foreign nationals to study at designated learning institutions (DLIs) in Canada. Most foreign nationals need a study permit to study in Canada. Make sure you have all the documents you need before you apply. You should apply before you travel to Canada.</p>
              <Link to={"https://www.canada.ca/en/immigration-refugees-citizenship/services/study-canada/study-permit.html"} target='blank'>For Further More Information Click Here</Link> <hr></hr>
              <Link to={"https://www.canada.ca/en/immigration-refugees-citizenship/services/study-canada/study-permit/get-documents/provincial-attestation-letter.html"} target='blank'>For Further More Information Click Here</Link>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header" id="heading49">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse49" aria-expanded="false" aria-controls="collapse49">
              IRCC Updates - Recap of Key Announcements
            </button>
          </h2>
          <div id="collapse49" className="accordion-collapse collapse" aria-labelledby="heading49" data-bs-parent="#accordionExample">
            <div className="accordion-body">
             <img src="/img/ircc.png" alt="img" style={{width: "100%"}}/>
             <img src="/img/ircc2.png" alt="img" style={{width: "100%"}}/>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header" id="heading59">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse59" aria-expanded="false" aria-controls="collapse59">
              New Language Proficiency Requirements for PGWP Applicants
            </button>
          </h2>
          <div id="collapse59" className="accordion-collapse collapse" aria-labelledby="heading59" data-bs-parent="#accordionExample">
            <div className="accordion-body">
             <img src="/img/lang.png" alt="img" style={{width: "100%"}}/>
            </div>
          </div>
        </div>


        <div className="accordion-item">
          <h2 className="accordion-header" id="heading69">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse69" aria-expanded="false" aria-controls="collapse69">
              Updates To Post-Graduation Work Permit (PGWP)
            </button>
          </h2>
          <div id="collapse69" className="accordion-collapse collapse" aria-labelledby="heading69" data-bs-parent="#accordionExample">
            <div className="accordion-body">
             <img src="/img/work-permit.png" alt="img" style={{width: "100%"}} />
            </div>
          </div>
        </div>

        {/* <div className="accordion-item">
  <h2 className="accordion-header" id="heading31">
    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse31" aria-expanded="false" aria-controls="collapse31">
    What’s a GIC (Guaranteed Investment Certificate)?
    </button>
  </h2>
  <div id="collapse31" className="accordion-collapse collapse" aria-labelledby="heading31" data-bs-parent="#accordionExample">
    <div className="accordion-body">
      <p>A GIC is an investment account that offers a guaranteed interest rate over a fixed period of time. With the Scotiabank AND CIBC Student GIC Program you can invest between $20,635 CAD – $50,000 CAD.</p>
      <ul>
        <li className="my-1">Wire transfer $20,841 CAD to CIBC in Canada. $20,635 CAD will be deposited into your CIBC Investment Account and $206.35 CAD will pay for the program fee.</li>
        <li className="my-1">Have $6,190.50 CAD plus any interest deposited into your student bank account when you arrive in Canada.</li>
        <li className="my-1">Receive a portion of your investment back each month for 12 months – approximately $1313 CAD each month.</li>
        <li className="my-1">After 12 months, you’ll have received your $20,635 CAD investment back, plus interest.</li>
      </ul>
    </div>
  </div>
</div> */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading31">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse31" aria-expanded="false" aria-controls="collapse31">
              Points To Remember For Successful Offers And Visas
            </button>
          </h2>
          <div id="collapse31" className="accordion-collapse collapse" aria-labelledby="heading31" data-bs-parent="#accordionExample">
            <div className="accordion-body">

              <div className="point-container">
                <div className="point-box">
                  <div className="icon-wrapper" aria-hidden="true">
                    {/* <!-- Icon resembling a document or paper with check --> */}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
                      <path d="M6 2h9a2 2 0 0 1 2 2v9l-2-2V4H6v16h5v2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
                      <path d="M21 14v-2h-6l2 2-2 2h6z" />
                    </svg>
                  </div>
                  <b>Do not apply for students who do not meet the IELTS criteria.</b> Minimum 6.0 with no band less than 6.0/5.5 for UG and overall 6.5 with no band less than 6.0 for PG.
                </div>

                <div className="point-box">
                  <div className="icon-wrapper" aria-hidden="true">
                    {/* <!-- Icon resembling a building or institution --> */}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
                      <path d="M3 21v-2h18v2H3zm16-7v6h-2v-6h-4v6h-2v-6H5V9l7-4 7 4v5z" />
                    </svg>
                  </div>
                  <b>Do not apply for students who have several failed courses, large gaps of 5 or more years</b> in studies (regardless of their work experience) and inconsistency in program choice with past studies. <b>Course choice must be relevant.</b>
                </div>

                <div className="point-box">
                  <div className="icon-wrapper" aria-hidden="true">
                    {/* <!-- Icon resembling a chat or communication bubble --> */}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
                      <path d="M20 2H4a2 2 0 0 0-2 2v16l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 11h8v2H6v-2z" />
                    </svg>
                  </div>
                  Good academics of the students: We have seen <b>higher rate of visa approvals for students having 60%</b> and above throughout their academic qualifications.
                </div>

                <div className="point-box">
                  <div className="icon-wrapper" aria-hidden="true">
                    {/* <!-- Icon resembling a graduation cap --> */}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
                      <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM3 10.41v4.19l7 3.82v-4.19l-7-3.82z" />
                    </svg>
                  </div>
                  Also, we have noticed that if a student has <b>low academics</b> as well as a <b>gap of 2-5 years</b> after completion of last studies, the case is weak, and visa may be refused.
                </div>
              </div>


            </div>
          </div>
        </div >
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading32">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse32" aria-expanded="false" aria-controls="collapse32">
              Points to Remember for Successful Offers and Visas
            </button>
          </h2>
          <div id="collapse32" className="accordion-collapse collapse" aria-labelledby="heading32" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <ul>
                <li className="my-1">Do not apply for students who do not meet the IELTS criteria. Minimum 6.0  with no band less than 6.0 for UG and overall 6.5 with no band less than 6.0 for  PG.</li>
                <li className="my-1">Do not apply for students who have several failed courses, large gaps of 5 or more years in studies (regardless of their work experience) and inconsistency in program choice with past studies. Course choice must be relevant.</li>
                <li className="my-1">Good academics of the students: We have seen higher rate of visa approval for  the students having 60% and above throughout their academic  qualifications.</li>
                <li className="my-1">Also we have noticed that if a student has low academics as well as a gap of 2‐5 years after completion of last studies, the case is weak and visa may be refused.</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading33">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse33" aria-expanded="false" aria-controls="collapse33">
              What is the difference between S1 and SW visa?
            </button>
          </h2>
          <div id="collapse33" className="accordion-collapse collapse" aria-labelledby="heading33" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <p><strong>➢ S1 is study only Visa. </strong></p>
              <p><strong>➢ SW1 is study and work visa. (Usually given to those students who are going for a Co-op program)</strong></p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading34">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse34" aria-expanded="false" aria-controls="collapse34">
              Who all can sponsor a student for Canada visa?
            </button>
          </h2>
          <div id="collapse34" className="accordion-collapse collapse" aria-labelledby="heading34" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <p><strong>➢ Student’s parents should ideally sponsor them for Visa. </strong></p>
              <p><strong>➢ The sponsor can also be the students themselves, spouse, siblings, paternal and maternal grandparents.</strong></p>
              <p><strong>➢ Third party sponsorship should not be more than 50% of the entire expense</strong></p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading35">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse35" aria-expanded="false" aria-controls="collapse35">
              What is CAQ?
            </button>
          </h2>
          <div id="collapse35" className="accordion-collapse collapse" aria-labelledby="heading35" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <ul>
                <li className="my-1">Québec Certificate of Acceptance (CAQ) – International students whose program in Québec lasts more than six months should be authorized to study by the ministère de l’Immigration, de la Diversité et de l’Inclusion (MIDI). </li>
                <li className="my-1">If any student is applying for any colleges in Quebec, it is necessary that they first apply for a CAQ and then for Visa.</li>
                <li className="my-1">There is an online application process for CAQ and the turn around time to receive the same is 5 -7 weeks. </li>
                <li className="my-1">Mentioned below is the link to apply for a CAQ <Link to={"https://www.quebec.ca/en/education/study-quebec/temporary-selection-studies"}>https://www.quebec.ca/en/education/study-quebec/temporary-selection-studies</Link> </li>
                <li className="my-1">Application fee for the same is CAD 132</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading36">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse36" aria-expanded="false" aria-controls="collapse36">
              Submitting a winning Application
            </button>
          </h2>
          <div id="collapse36" className="accordion-collapse collapse" aria-labelledby="heading36" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <ul>
                <li className="my-1">Completed Application Form</li>
                <li className="my-1">Academic Records</li>
                <li className="my-1">Standardized Examination Scores</li>
                <li className="my-1">Work Experience details if any</li>
                <li className="my-1">Application Fees if applicable</li>
              </ul>
              <p>No SOP or Recommendation Letters  required for Community Collegesy Colleges</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading37">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse37" aria-expanded="false" aria-controls="collapse37">
              Counseling Tips
            </button>
          </h2>
          <div id="collapse37" className="accordion-collapse collapse" aria-labelledby="heading37" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              <ul>
                <li className="my-1">Identify the profile suitability for Canada.</li>
                <li className="my-1">Do not accept students below 50% for  Colleges* and below 65% for Masters in the University.</li>
                <li className="my-1">Declare in advance students with long gaps in their Education and multiple backlogs.</li>
                <li className="my-1">Check English Language ability.</li>
                <li className="my-1">Inform the student about the benefits of studying in Canada  as compared to other countries.</li>
                <li className="my-1">Most Important – Talk about PR Opportunity, Part time work ,full time job opportunities.</li>
                <li className="my-1">Talk about the lesser investment and higher gains (Less fees).</li>
              </ul>
            </div>
          </div>
        </div>

      </div >

    </>
  )
}
